import { useSearch } from '@tanstack/react-router';

import { roleSchema } from '@nesso/identity-contracts/oauth.commands';

import { ContinueWithGoogle } from '@/features/users/continue-with-google';
import { SignUpWithEmail } from '@/features/users/sign-up-with-email';
import { AuthCard } from '@/shared/ui/auth/auth-card';
import { AuthOrDivider } from '@/shared/ui/auth/auth-or-divider';
import { ThreatProtectionScript } from '@/shared/ui/auth/threat-protection-script';

import { ConsentText } from './signup-page/consent-text';

export function SignupPage() {
    const { signUpData } = useSearch({ from: '/signup' });

    return (
        <>
            <ThreatProtectionScript />
            <div className="flex flex-1 items-start justify-center px-4 mb-13">
                <AuthCard className="mt-20 sm:mt-18">
                    <div className="flex flex-col gap-2 sm:gap-3 sm:mb-3">
                        <h1 className="text-3xl font-bold md:text-4xl">
                            Start your 5-day free trial
                        </h1>
                        <ConsentText />
                    </div>
                    <ContinueWithGoogle role={roleSchema.enum.clinician} signUpData={signUpData} />
                    <AuthOrDivider />
                    <SignUpWithEmail signUpData={signUpData} />
                </AuthCard>
            </div>
        </>
    );
}
